[
  [-0.084, 0.3297],
  [-0.0609, 0.3297],
  [-0.0378, 0.3297],
  [-0.0147, 0.3297],
  [0.0084, 0.3297],
  [0.0315, 0.3297],
  [0.0546, 0.3297],
  [0.0777, 0.3297],
  [-0.315, 0.3066],
  [-0.2919, 0.3066],
  [-0.2688, 0.3066],
  [-0.2457, 0.3066],
  [-0.2226, 0.3066],
  [-0.1302, 0.3066],
  [-0.1071, 0.3066],
  [-0.084, 0.3066],
  [-0.0609, 0.3066],
  [-0.0378, 0.3066],
  [-0.0147, 0.3066],
  [0.0084, 0.3066],
  [0.0315, 0.3066],
  [0.0546, 0.3066],
  [0.0777, 0.3066],
  [0.1008, 0.3066],
  [0.1239, 0.3066],
  [0.147, 0.3066],
  [0.2163, 0.3066],
  [0.2394, 0.3066],
  [0.2625, 0.3066],
  [0.2856, 0.3066],
  [-0.3381, 0.2835],
  [-0.315, 0.2835],
  [-0.2919, 0.2835],
  [-0.2688, 0.2835],
  [-0.2457, 0.2835],
  [-0.2226, 0.2835],
  [-0.1995, 0.2835],
  [-0.1764, 0.2835],
  [-0.1533, 0.2835],
  [-0.1302, 0.2835],
  [-0.1071, 0.2835],
  [-0.084, 0.2835],
  [0.0777, 0.2835],
  [0.1008, 0.2835],
  [0.1239, 0.2835],
  [0.147, 0.2835],
  [0.1701, 0.2835],
  [0.1932, 0.2835],
  [0.2163, 0.2835],
  [0.2394, 0.2835],
  [0.2625, 0.2835],
  [0.2856, 0.2835],
  [0.3087, 0.2835],
  [-0.3381, 0.2604],
  [-0.315, 0.2604],
  [-0.2919, 0.2604],
  [-0.2688, 0.2604],
  [-0.2457, 0.2604],
  [-0.2226, 0.2604],
  [-0.1995, 0.2604],
  [-0.1764, 0.2604],
  [-0.1533, 0.2604],
  [-0.1302, 0.2604],
  [0.147, 0.2604],
  [0.1701, 0.2604],
  [0.1932, 0.2604],
  [0.2163, 0.2604],
  [0.2394, 0.2604],
  [0.2625, 0.2604],
  [0.2856, 0.2604],
  [0.3087, 0.2604],
  [0.3318, 0.2604],
  [-0.3381, 0.2373],
  [-0.315, 0.2373],
  [-0.2919, 0.2373],
  [-0.2688, 0.2373],
  [-0.2457, 0.2373],
  [-0.2226, 0.2373],
  [-0.1995, 0.2373],
  [-0.1764, 0.2373],
  [-0.1533, 0.2373],
  [0.1701, 0.2373],
  [0.1932, 0.2373],
  [0.2163, 0.2373],
  [0.2394, 0.2373],
  [0.2625, 0.2373],
  [0.2856, 0.2373],
  [0.3087, 0.2373],
  [0.3318, 0.2373],
  [-0.3381, 0.2142],
  [-0.315, 0.2142],
  [-0.2919, 0.2142],
  [-0.2688, 0.2142],
  [-0.2457, 0.2142],
  [-0.2226, 0.2142],
  [-0.1995, 0.2142],
  [-0.1764, 0.2142],
  [-0.1533, 0.2142],
  [0.2163, 0.2142],
  [0.2394, 0.2142],
  [0.2625, 0.2142],
  [0.2856, 0.2142],
  [0.3087, 0.2142],
  [0.3318, 0.2142],
  [-0.3381, 0.1911],
  [-0.315, 0.1911],
  [-0.2919, 0.1911],
  [-0.2688, 0.1911],
  [-0.2457, 0.1911],
  [-0.2226, 0.1911],
  [-0.1995, 0.1911],
  [-0.1764, 0.1911],
  [0.2394, 0.1911],
  [0.2625, 0.1911],
  [0.2856, 0.1911],
  [0.3087, 0.1911],
  [0.3318, 0.1911],
  [-0.315, 0.168],
  [-0.2919, 0.168],
  [-0.2688, 0.168],
  [-0.2457, 0.168],
  [-0.2226, 0.168],
  [-0.1995, 0.168],
  [-0.1764, 0.168],
  [0.2625, 0.168],
  [0.2856, 0.168],
  [0.3087, 0.168],
  [-0.315, 0.1449],
  [-0.2919, 0.1449],
  [-0.2688, 0.1449],
  [-0.2457, 0.1449],
  [-0.2226, 0.1449],
  [-0.1995, 0.1449],
  [-0.1764, 0.1449],
  [0.2625, 0.1449],
  [0.2856, 0.1449],
  [0.3087, 0.1449],
  [-0.315, 0.1218],
  [-0.2919, 0.1218],
  [-0.2688, 0.1218],
  [-0.2457, 0.1218],
  [-0.2226, 0.1218],
  [-0.1995, 0.1218],
  [-0.1764, 0.1218],
  [0.2856, 0.1218],
  [0.3087, 0.1218],
  [-0.3381, 0.0987],
  [-0.315, 0.0987],
  [-0.2919, 0.0987],
  [-0.2688, 0.0987],
  [-0.2457, 0.0987],
  [-0.2226, 0.0987],
  [-0.1995, 0.0987],
  [-0.1764, 0.0987],
  [0.2856, 0.0987],
  [0.3087, 0.0987],
  [0.3318, 0.0987],
  [-0.3381, 0.0756],
  [-0.315, 0.0756],
  [-0.2919, 0.0756],
  [-0.2688, 0.0756],
  [-0.2457, 0.0756],
  [-0.2226, 0.0756],
  [-0.1995, 0.0756],
  [-0.1764, 0.0756],
  [0.3087, 0.0756],
  [0.3318, 0.0756],
  [-0.3381, 0.0525],
  [-0.315, 0.0525],
  [-0.2919, 0.0525],
  [-0.2688, 0.0525],
  [-0.2457, 0.0525],
  [-0.2226, 0.0525],
  [-0.1995, 0.0525],
  [-0.1764, 0.0525],
  [-0.1533, 0.0525],
  [0.3087, 0.0525],
  [0.3318, 0.0525],
  [-0.3612, 0.0294],
  [-0.3381, 0.0294],
  [-0.315, 0.0294],
  [-0.2919, 0.0294],
  [-0.2688, 0.0294],
  [-0.2457, 0.0294],
  [-0.2226, 0.0294],
  [-0.1995, 0.0294],
  [-0.1764, 0.0294],
  [-0.1533, 0.0294],
  [-0.1302, 0.0294],
  [0.3318, 0.0294],
  [0.3549, 0.0294],
  [-0.3612, 0.0063],
  [-0.3381, 0.0063],
  [-0.315, 0.0063],
  [-0.2919, 0.0063],
  [-0.2688, 0.0063],
  [-0.2457, 0.0063],
  [-0.2226, 0.0063],
  [-0.1995, 0.0063],
  [-0.1764, 0.0063],
  [-0.1533, 0.0063],
  [-0.1302, 0.0063],
  [-0.1071, 0.0063],
  [0.3318, 0.0063],
  [0.3549, 0.0063],
  [-0.3612, -0.0168],
  [-0.3381, -0.0168],
  [-0.315, -0.0168],
  [-0.2919, -0.0168],
  [-0.2688, -0.0168],
  [-0.2457, -0.0168],
  [-0.2226, -0.0168],
  [-0.1995, -0.0168],
  [-0.1764, -0.0168],
  [-0.1533, -0.0168],
  [-0.1302, -0.0168],
  [-0.1071, -0.0168],
  [-0.084, -0.0168],
  [-0.0609, -0.0168],
  [-0.0378, -0.0168],
  [0.3318, -0.0168],
  [0.3549, -0.0168],
  [-0.3612, -0.0399],
  [-0.3381, -0.0399],
  [-0.315, -0.0399],
  [-0.2919, -0.0399],
  [-0.2688, -0.0399],
  [-0.2457, -0.0399],
  [-0.2226, -0.0399],
  [-0.1995, -0.0399],
  [-0.1764, -0.0399],
  [-0.1533, -0.0399],
  [-0.1302, -0.0399],
  [-0.1071, -0.0399],
  [-0.084, -0.0399],
  [-0.0609, -0.0399],
  [-0.0378, -0.0399],
  [-0.0147, -0.0399],
  [0.0084, -0.0399],
  [0.0315, -0.0399],
  [0.0546, -0.0399],
  [0.3318, -0.0399],
  [0.3549, -0.0399],
  [-0.3612, -0.063],
  [-0.3381, -0.063],
  [-0.315, -0.063],
  [-0.2919, -0.063],
  [-0.2688, -0.063],
  [-0.2457, -0.063],
  [-0.2226, -0.063],
  [-0.1995, -0.063],
  [-0.1764, -0.063],
  [-0.1533, -0.063],
  [-0.1302, -0.063],
  [-0.1071, -0.063],
  [-0.084, -0.063],
  [-0.0609, -0.063],
  [-0.0378, -0.063],
  [-0.0147, -0.063],
  [0.0084, -0.063],
  [0.0315, -0.063],
  [0.0546, -0.063],
  [0.0777, -0.063],
  [0.3318, -0.063],
  [0.3549, -0.063],
  [-0.3612, -0.0861],
  [-0.3381, -0.0861],
  [-0.315, -0.0861],
  [-0.2919, -0.0861],
  [-0.2688, -0.0861],
  [-0.2457, -0.0861],
  [-0.2226, -0.0861],
  [-0.1995, -0.0861],
  [-0.1764, -0.0861],
  [-0.1533, -0.0861],
  [-0.1302, -0.0861],
  [-0.1071, -0.0861],
  [-0.084, -0.0861],
  [-0.0609, -0.0861],
  [-0.0378, -0.0861],
  [-0.0147, -0.0861],
  [0.0084, -0.0861],
  [0.0315, -0.0861],
  [0.0546, -0.0861],
  [0.0777, -0.0861],
  [0.1008, -0.0861],
  [0.3318, -0.0861],
  [0.3549, -0.0861],
  [-0.3612, -0.1092],
  [-0.3381, -0.1092],
  [-0.315, -0.1092],
  [-0.2919, -0.1092],
  [-0.2688, -0.1092],
  [-0.2457, -0.1092],
  [-0.2226, -0.1092],
  [-0.1995, -0.1092],
  [-0.1764, -0.1092],
  [-0.1533, -0.1092],
  [-0.1302, -0.1092],
  [-0.1071, -0.1092],
  [-0.084, -0.1092],
  [-0.0609, -0.1092],
  [-0.0378, -0.1092],
  [-0.0147, -0.1092],
  [0.0084, -0.1092],
  [0.0315, -0.1092],
  [0.0546, -0.1092],
  [0.0777, -0.1092],
  [0.1008, -0.1092],
  [0.1239, -0.1092],
  [0.3318, -0.1092],
  [0.3549, -0.1092],
  [-0.3381, -0.1323],
  [-0.315, -0.1323],
  [-0.2919, -0.1323],
  [-0.2688, -0.1323],
  [-0.2457, -0.1323],
  [-0.2226, -0.1323],
  [-0.1995, -0.1323],
  [-0.1764, -0.1323],
  [-0.1533, -0.1323],
  [-0.1302, -0.1323],
  [-0.1071, -0.1323],
  [-0.084, -0.1323],
  [-0.0609, -0.1323],
  [-0.0378, -0.1323],
  [-0.0147, -0.1323],
  [0.0084, -0.1323],
  [0.0315, -0.1323],
  [0.0546, -0.1323],
  [0.0777, -0.1323],
  [0.1008, -0.1323],
  [0.1239, -0.1323],
  [0.3318, -0.1323],
  [0.3549, -0.1323],
  [-0.3381, -0.1554],
  [-0.315, -0.1554],
  [-0.2919, -0.1554],
  [-0.2688, -0.1554],
  [-0.2457, -0.1554],
  [-0.2226, -0.1554],
  [-0.1995, -0.1554],
  [-0.1764, -0.1554],
  [-0.1533, -0.1554],
  [-0.1302, -0.1554],
  [-0.1071, -0.1554],
  [-0.084, -0.1554],
  [-0.0609, -0.1554],
  [-0.0378, -0.1554],
  [-0.0147, -0.1554],
  [0.0084, -0.1554],
  [0.0315, -0.1554],
  [0.0546, -0.1554],
  [0.0777, -0.1554],
  [0.1008, -0.1554],
  [0.1239, -0.1554],
  [0.3087, -0.1554],
  [0.3318, -0.1554],
  [-0.3381, -0.1785],
  [-0.315, -0.1785],
  [-0.2919, -0.1785],
  [-0.2688, -0.1785],
  [-0.2457, -0.1785],
  [-0.2226, -0.1785],
  [-0.1995, -0.1785],
  [-0.1764, -0.1785],
  [-0.1533, -0.1785],
  [-0.1302, -0.1785],
  [-0.1071, -0.1785],
  [-0.084, -0.1785],
  [-0.0609, -0.1785],
  [-0.0378, -0.1785],
  [-0.0147, -0.1785],
  [0.0084, -0.1785],
  [0.0315, -0.1785],
  [0.0546, -0.1785],
  [0.0777, -0.1785],
  [0.1008, -0.1785],
  [0.1239, -0.1785],
  [0.3087, -0.1785],
  [0.3318, -0.1785],
  [-0.315, -0.2016],
  [-0.2919, -0.2016],
  [-0.2688, -0.2016],
  [-0.2457, -0.2016],
  [-0.2226, -0.2016],
  [-0.1995, -0.2016],
  [-0.1764, -0.2016],
  [-0.1533, -0.2016],
  [-0.1302, -0.2016],
  [-0.1071, -0.2016],
  [-0.084, -0.2016],
  [-0.0609, -0.2016],
  [-0.0378, -0.2016],
  [-0.0147, -0.2016],
  [0.0084, -0.2016],
  [0.0315, -0.2016],
  [0.0546, -0.2016],
  [0.0777, -0.2016],
  [0.1008, -0.2016],
  [0.1239, -0.2016],
  [0.2856, -0.2016],
  [0.3087, -0.2016],
  [-0.2919, -0.2247],
  [-0.2688, -0.2247],
  [-0.2457, -0.2247],
  [-0.2226, -0.2247],
  [-0.1995, -0.2247],
  [-0.1764, -0.2247],
  [-0.1533, -0.2247],
  [-0.1302, -0.2247],
  [-0.1071, -0.2247],
  [-0.084, -0.2247],
  [-0.0609, -0.2247],
  [-0.0378, -0.2247],
  [-0.0147, -0.2247],
  [0.0084, -0.2247],
  [0.0315, -0.2247],
  [0.0546, -0.2247],
  [0.0777, -0.2247],
  [0.1008, -0.2247],
  [0.2625, -0.2247],
  [0.2856, -0.2247],
  [0.3087, -0.2247],
  [-0.2688, -0.2478],
  [-0.2457, -0.2478],
  [-0.2226, -0.2478],
  [-0.1995, -0.2478],
  [-0.1764, -0.2478],
  [-0.1533, -0.2478],
  [-0.1302, -0.2478],
  [-0.1071, -0.2478],
  [-0.084, -0.2478],
  [-0.0609, -0.2478],
  [-0.0378, -0.2478],
  [-0.0147, -0.2478],
  [0.0084, -0.2478],
  [0.0315, -0.2478],
  [0.0546, -0.2478],
  [0.0777, -0.2478],
  [0.2163, -0.2478],
  [0.2394, -0.2478],
  [0.2625, -0.2478],
  [0.2856, -0.2478],
  [-0.2457, -0.2709],
  [-0.2226, -0.2709],
  [-0.1995, -0.2709],
  [-0.1764, -0.2709],
  [-0.1533, -0.2709],
  [-0.1302, -0.2709],
  [-0.1071, -0.2709],
  [-0.084, -0.2709],
  [-0.0609, -0.2709],
  [-0.0378, -0.2709],
  [-0.0147, -0.2709],
  [0.0084, -0.2709],
  [0.0315, -0.2709],
  [0.0546, -0.2709],
  [0.147, -0.2709],
  [0.1701, -0.2709],
  [0.1932, -0.2709],
  [0.2163, -0.2709],
  [0.2394, -0.2709],
  [-0.1995, -0.294],
  [-0.1764, -0.294],
  [-0.1533, -0.294],
  [-0.1302, -0.294],
  [-0.1071, -0.294],
  [-0.084, -0.294],
  [-0.0609, -0.294],
  [-0.0378, -0.294],
  [-0.0147, -0.294],
  [0.0084, -0.294],
  [0.0315, -0.294],
  [0.0546, -0.294],
  [0.0777, -0.294],
  [0.1008, -0.294],
  [0.1239, -0.294],
  [0.147, -0.294],
  [0.1701, -0.294],
  [0.1932, -0.294],
  [0.2163, -0.294],
  [-0.1302, -0.3171],
  [-0.1071, -0.3171],
  [-0.084, -0.3171],
  [-0.0609, -0.3171],
  [-0.0378, -0.3171],
  [-0.0147, -0.3171],
  [0.0084, -0.3171],
  [0.0315, -0.3171],
  [0.0546, -0.3171],
  [0.0777, -0.3171],
  [0.1008, -0.3171],
  [0.1239, -0.3171],
  [0.147, -0.3171]
]
